import React, { forwardRef } from 'react';
import PropType from 'prop-types';
import { Badge, Button } from '@mui/material';

const CustomRecordAttendanceBtn = forwardRef(({ params, handleMoreMenuTogglePopper, moreMenuOpen }, ref) => {
    const handleClick = () => handleMoreMenuTogglePopper(params.row.lead_id);
    const count = params.row?.lead_treatments__lead_contacted_counts__count;

    return (
        <Badge
            badgeContent={count}
            color="primary"
            overlap="rectangular"
            invisible={!count || count === 0}
            sx={{
                '& .MuiBadge-badge': {
                    bgcolor: 'primary.darker',
                    color: 'common.white',
                    fontSize: '0.65rem',
                    minWidth: 16,
                    height: 16,
                    padding: '0 4px',
                    top: 4,
                    right: 4,
                },
            }}
        >
            <Button
                ref={ref}
                onClick={handleClick}
                aria-controls={moreMenuOpen ? 'split-button-menu' : undefined}
                aria-expanded={moreMenuOpen ? 'true' : undefined}
                aria-haspopup="menu"
                id={`menuButton-${params.row.lead_id}`}
                variant="contained"
                color="primary"
                disableElevation
                sx={{
                    borderRadius: '8px',
                    p: '6px 14px',
                    fontSize: '0.8125rem',
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                    boxShadow: '0px 4px 10px rgba(0, 167, 111, 0.24)',
                    '&:hover': {
                        bgcolor: 'primary.dark',
                        boxShadow: '0px 4px 10px rgba(0, 167, 111, 0.24)',
                    },
                }}
            >
                Record Attendance
            </Button>
        </Badge>
    );
});

export default CustomRecordAttendanceBtn;

CustomRecordAttendanceBtn.propTypes = {
    params: PropType.any,
    handleMoreMenuTogglePopper: PropType.func,
    moreMenuOpen: PropType.bool,
};
